import React, { useState, useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import PendingActionsAlert from "./PendingActionsAlert";
import api from "@/services/api";

const ManagerPendingActionsWrapper = ({ children }) => {
  const { isAuthenticated, user } = useAuth();
  const [showAlert, setShowAlert] = useState(false);
  const [pendingActions, setPendingActions] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // Fetch pending actions whenever the component mounts or user refreshes
  useEffect(() => {
    const fetchPendingActions = async () => {
      if (!isAuthenticated || !user) return;

      try {
        setIsLoading(true);

        // Call backend to get current pending actions
        const response = await api.get("/auth/pending-actions");

        if (response.data?.success && response.data.data?.pendingActions) {
          const actions = response.data.data.pendingActions;

          if (actions.total > 0) {
            setPendingActions(actions);

            // Show alert after a short delay
            setTimeout(() => {
              setShowAlert(true);
            }, 1000);
          }
        }
      } catch (error) {
        console.error("Error fetching pending actions:", error);
        // Silently fail - don't show error to user
      } finally {
        setIsLoading(false);
      }
    };

    fetchPendingActions();
  }, [isAuthenticated, user]); // Re-run when authentication state changes

  const handleCloseAlert = () => {
    setShowAlert(false);
  };

  return (
    <>
      {children}
      {showAlert && pendingActions && (
        <PendingActionsAlert
          pendingActions={pendingActions}
          onClose={handleCloseAlert}
        />
      )}
    </>
  );
};

export default ManagerPendingActionsWrapper;
